import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import {
  COLOR_GREYSCALE_NTA_BLACK_8,
  COLOR_GREYSCALE_NTA_BLACK_15,
  COLOR_GREYSCALE_NTA_BLACK_25,
} from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { BACK_TO_TOP_BUTTON_CLASSES } from "./constants";

export const BackToTopButtonContainer = styled(Button)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    position: "fixed",
    display: "none",
    bottom: 32,
    right: 0,
    width: 48,
    height: 48,
    zIndex: 99,
    backgroundColor: COLOR_GREYSCALE_NTA_BLACK_8,
    opacity: 0,
    transform: "translateX(100%)",
    transition: "opacity 0.3s ease-out, transform 0.3s ease-out",
    willChange: "transform, opacity",
    "&:hover": {
      backgroundColor: COLOR_GREYSCALE_NTA_BLACK_15,
    },
    "&:active": {
      backgroundColor: COLOR_GREYSCALE_NTA_BLACK_25,
    },
    "&.MuiButtonBase-root:before": {
      content: "none",
    },
    cursor: "pointer",
    [formatMedia.BREAKPOINT_DESKTOP]: {
      display: "block",
    },
    [`&.${BACK_TO_TOP_BUTTON_CLASSES.isVisible}`]: {
      opacity: 1,
      transform: "translateX(0)",
    },
    [`&.${BACK_TO_TOP_BUTTON_CLASSES.isHidden}`]: {
      opacity: 0,
      transform: "translateX(100%)",
    },
    [`& .${BACK_TO_TOP_BUTTON_CLASSES.up}`]: {
      position: "absolute",
      top: 12,
      left: 16,
    },
    [`& .${BACK_TO_TOP_BUTTON_CLASSES.caption}`]: {
      top: 28,
      left: 0,
      right: 0,
      position: "absolute",
      textAlign: "center",
      userSelect: "none",
    },
  };
});
